import { createEntityAdapter } from '@reduxjs/toolkit';
import { TeamGroup } from '../../domain/interfaces/team-group';
import { compareTeamGroups } from '../../domain/utils/compare-team-groups';

const groupsAdapter = createEntityAdapter<TeamGroup>({
  selectId: (group) => group.id,
  sortComparer: compareTeamGroups,
});

export default groupsAdapter;
